<template>
  <collapse :active-index="collapsed ? -1 : 0">
    <collapse-item>
      <template slot="title">
        <slot name="title">
          <h3 class="mb-0">Contactos</h3>
        </slot>
      </template>

      <ul class="list-group list-group-flush list my--3">
        <li v-for="contact in contacts" :key="contact.id" class="list-group-item px-0">
          <div class="row align-items-center">
            <div class="col">
              <h4 class="mb-0 text-uppercase">{{ contact.name }}</h4>
              <div v-if="contact.email" class="small mt-1"><label>Email:&nbsp;</label>{{ contact.email }}</div>
              <div v-if="contact.position" class="small font-italic font-weight-bold">
                <label>Puesto:&nbsp;</label>{{ contact.position }}
              </div>
              <div v-if="contact.phone" class="small mt-1">
                <label><span class="text-success">● </span>Teléfono:&nbsp;</label>{{ contact.phone }}
              </div>
            </div>
            <div v-if="edition" class="col-auto">
              <base-button outline size="sm" type="success" @click="editContact(contact)">
                <i class="fas fa-pen"></i>
              </base-button>
              <base-button outline size="sm" type="danger" @click="deleteContact(contact.id)">
                <i class="fas fa-trash"></i>
              </base-button>
            </div>
            <div v-else class="col-auto">
              <a
                :class="{ disabled: contact.email === null }"
                :href="`mailto:${contact.email}`"
                class="btn base-button btn-outline-primary btn-sm"
              >
                <i class="fas fa-envelope"></i>
              </a>
              <a
                :class="{ disabled: contact.phone === null }"
                :href="`tel:+549${contact.phone}`"
                class="btn base-button btn-outline-default btn-sm"
              >
                <i class="fas fa-phone"></i>
              </a>
            </div>
          </div>
        </li>

        <li v-if="contacts.length === 0" class="list-group-item px-0">
          <div class="row align-items-center">
            <div class="col">
              <h4 class="mb-0">No hay contactos cargados.</h4>
            </div>
          </div>
        </li>
      </ul>
    </collapse-item>
  </collapse>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';
import ContactEventBus from '@/events/buses/contacts.event';
import swal from 'sweetalert2';

export default {
  name: 'ContactsList',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    title: {
      type: String,
      default: 'Todos los Contactos',
    },

    entityId: {
      type: Number,
      default: null,
    },

    entity: {
      type: String,
      default: '',
    },

    collapsed: {
      type: Boolean,
      default: true,
    },

    edition: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      contacts: [],
    };
  },

  created() {
    ContactEventBus.$on('contacts-add-to-list', this.addToList);
    ContactEventBus.$on('contacts-on-update', this.updateContact);

    const parameters = {
      'filter[entity]': this.entity,
      'filter[entity_id]': this.entityId,
      include: ['contactable'],
    };

    this.$services
      .resource('contacts')
      .get(parameters)
      .then((res) => res.data.data)
      .then((data) => {
        this.contacts = data.contacts;
        ContactEventBus.loaded();
      });
  },

  beforeDestroy() {
    ContactEventBus.$off('contacts-add-to-list', this.addToList);
    ContactEventBus.$off('contacts-on-update', this.updateContact);
  },

  methods: {
    editContact(contact) {
      ContactEventBus.edit(contact);
    },

    updateContact(contact) {
      let result = this.contacts.find((c) => c.id === contact.id);
      result.name = contact.name;
      result.position = contact.position;
      result.phone = contact.phone;
      result.email = contact.email;
    },

    deleteContact(id) {
      const index = this.contacts.findIndex((c) => c.id === id);
      this.$services
        .resource('contacts')
        .delete(id)
        .then((res) => this.contacts.splice(index, 1))
        .finally(() => {
          swal({
            title: 'Listo!',
            text: 'El contacto fue eliminado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          });
        });
    },

    addToList(contact) {
      this.contacts.push(contact);
    },
  },
};
</script>

<style scoped>
a.disabled {
  pointer-events: none;
  cursor: default;
  transform: none;
  box-shadow: none;
}
</style>
